import { defineComponent as _defineComponent } from 'vue'
import type { PropType } from 'vue'


export default /*#__PURE__*/_defineComponent({
  __name: 'InputText',
  props: {
    value: { default: null },
    type: { default: 'text' },
    classes: { default: () => ({}) },
    disabled: { type: Boolean, default: false },
    readonly: { type: Boolean, default: false },
    placeholder: { default: '' },
    invalid: { type: Boolean, default: false },
    selectOnFocus: { type: Boolean, default: false }
  },
  emits: ["input", "blur"],
  setup(__props: any, { emit }: { emit: ({
  (event: 'input', value: string | number | null): void
  (event: 'blur', value: string): void
}), expose: any, slots: any, attrs: any }) {

const props = __props as { value: PropType<string | number> | null, type: string, classes: any, disabled: boolean, readonly: boolean, placeholder: string, invalid: boolean, selectOnFocus: boolean };





const onInput = (e: any) => {
  const value = !e.target?.value ? null : e.target.value

  emit('input', value)
}

const onBlur = (e: any) => {
  emit('blur', !e.target?.value ? null : e.target.value)
}

const onFocus = (event: FocusEvent | KeyboardEvent) => {
  if (props.selectOnFocus && event.target instanceof HTMLInputElement) event.target.select()
}

return { __sfc: true,props, emit, onInput, onBlur, onFocus }
}

})